const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.896,
    height: 107.996,
    viewBox: "0 0 103.896 107.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5056",
    d: "M16.314 324.308a21.535 21.535 0 1 0 30.456 30.454l2.172-2.176-30.454-30.456z",
    transform: "translate(-8.503 -254.564)",
    style: {
      fill: "none",
      stroke: "#f6b119",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5057",
    d: "M248.593 152.662a21.535 21.535 0 1 0-30.456-30.454l-2.172 2.174 30.456 30.456z",
    transform: "translate(-172.225 -90.625)",
    style: {
      fill: "none",
      stroke: "#f6b119",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5058",
    d: "m97.635 178.51-25.06 25.1 30.454 30.454 25.062-25.1z",
    transform: "translate(-58.242 -140.399)",
    style: {
      fill: "none",
      stroke: "#f6b119",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5059",
    d: "M343.791 24.548a9.226 9.226 0 0 0-12.258-12.4l-4.725-4.725 2.175-2.175A3.076 3.076 0 1 0 324.633.9l-8.7 8.7a3.076 3.076 0 0 0 4.35 4.351l2.175-2.175 4.35 4.35-4.183 4.184a27.84 27.84 0 0 1 13.038 13.064l4.075-4.076a27.726 27.726 0 0 1-2.053 36.86l-11.251 11.254a9.221 9.221 0 1 0 4.355 4.347l11.247-11.247a33.885 33.885 0 0 0 1.755-45.964z",
    transform: "translate(-249.538 1.499)",
    style: {
      fill: "none",
      stroke: "#f6b119",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivity);
export default __webpack_public_path__ + "static/media/no-activity.4d8ee8097da61543e94dedd8842e13bd.svg";
export { ForwardRef as ReactComponent };